// components
import { TPersona } from '@newo/api/gateway';
import PersonaForm from '@/modules/Personas/components/PersonaForm';
// utils

interface DetailsProps {
    persona: TPersona;
    onSubmit: () => void;
    onClose: () => void;
}

const Details = ({ onSubmit, onClose, persona }: DetailsProps) => {
    return (
        <PersonaForm persona={persona} onClose={onClose} onSubmit={onSubmit} />
    );
};

export default Details;
